module.exports = __webpack_public_path__ + "img/side_macro_2.00d68eb7.png";